import axios from "axios";
import { useState } from "react";
import { BASE_URL } from "../../config";
import store from "../../store/store";
import * as actionTypes from "../../store/actions";
import { getWord } from "../../utils/functions";
import { setSession } from "../../helpers/auth";

const Login = ({ isOpen, onClose }) => {
  const [modalType, setModalType] = useState("login");
  const switchTo = (type) => setModalType(type);

  const [data, setData] = useState({
    fname: "",
    lname: "",
    email: "",
    password: "",
    phone: "",
    errors: {},
    loading: false,
  });

  const { fname, lname, email, password, phone, errors, loading } = data;

  const handleChange = (e) => {
    setData((data) => ({
      ...data,
      [e.target.name]: e.target.value.trim(),
      errors: { ...data.errors, [e.target.name]: "" },
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setData((data) => ({
      ...data,
      errors: {},
      loading: true,
    }));
    try {
      const response = await axios.post(`${BASE_URL}/user/login`, {
        email,
        password,
      });
      const result = response.data;
      store.dispatch({
        type: actionTypes.UPDATE_USERDATA,
        payload: { userdata: result.user },
      });
      const token = window.location.hostname.replace(".com", "");
      setSession(token);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.messages) {
        const messages = err.response.data.messages;
        Object.entries(messages).map(([field, message]) =>
          setData((data) => ({
            ...data,
            errors: { ...data.errors, [field]: message },
          }))
        );
      } else {
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "An unexpected error occurred" },
        }));
      }
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setData((data) => ({
      ...data,
      errors: {},
      loading: true,
    }));
    try {
      const response = await axios.post(`${BASE_URL}/user/register`, {
        fname,
        lname,
        email,
        password,
        phone,
      });
      const result = response.data;
      if (result.message === "Success") {
        store.dispatch({
          type: actionTypes.UPDATE_USERDATA,
          payload: { userdata: result.user },
        });
        const token = window.location.hostname.replace(".com", "");
        setSession(token);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.messages) {
        const messages = err.response.data.messages;
        Object.entries(messages).map(([field, message]) =>
          setData((data) => ({
            ...data,
            errors: { ...data.errors, [field]: message },
          }))
        );
      } else {
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "An unexpected error occurred" },
        }));
      }
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setData((data) => ({
      ...data,
      errors: {},
      loading: true,
    }));
    try {
      const response = await axios.post(`${BASE_URL}/user/reset`, {
        email,
      });
      const result = response.data;
      setData((data) => ({
        ...data,
        errors: { ...data.errors, error: "Email Sent Successfully" },
      }));
    } catch (err) {
      if (err.response && err.response.data && err.response.data.messages) {
        const messages = err.response.data.messages;
        Object.entries(messages).map(([field, message]) =>
          setData((data) => ({
            ...data,
            errors: { ...data.errors, [field]: message },
          }))
        );
      } else {
        setData((data) => ({
          ...data,
          errors: { ...data.errors, error: "An unexpected error occurred" },
        }));
      }
    } finally {
      setData((data) => ({ ...data, loading: false }));
    }
  };

  return isOpen ? (
    <>
      <div
        className="modal modalCentered fade form-sign-in modal-part-content show"
        style={{ display: "block" }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          {modalType === "login" && (
            <>
              <div className="modal-content">
                <div className="header">
                  <div className="demo-title">{getWord("Log In")}</div>
                  <span
                    className="icon-close icon-close-popup"
                    data-bs-dismiss="modal"
                    onClick={onClose}
                  ></span>
                </div>
                <div className="tf-login-form">
                  <form onSubmit={handleLogin} autoComplete="off">
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Email")} *
                      </label>
                      {errors.email && (
                        <div className="error">{errors.email}</div>
                      )}
                    </div>
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="password"
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Password")} *
                      </label>
                      {errors.password && (
                        <div className="error">{errors.password}</div>
                      )}
                    </div>
                    <div>
                      <a
                        data-bs-toggle="modal"
                        className="btn-link link"
                        onClick={() => switchTo("forget_password")}
                      >
                        {getWord("Forgot your password?")}
                      </a>
                    </div>
                    <div className="bottom">
                      <div className="w-100">
                        <button
                          type="submit"
                          className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                          disabled={loading}
                        >
                          {loading ? getWord("Logging In") : getWord("Login")}
                        </button>
                        {errors.error && (
                          <div className="error">{errors.error}</div>
                        )}
                      </div>
                      <div className="w-100">
                        <a
                          data-bs-toggle="modal"
                          className="btn-link fw-6 w-100 link"
                          onClick={() => switchTo("register")}
                        >
                          {getWord("New customer? Create your account")}
                          <i className="icon icon-arrow1-top-left"></i>
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
          {modalType === "register" && (
            <>
              <div className="modal-content">
                <div className="header">
                  <div className="demo-title">{getWord("Register")}</div>
                  <span
                    className="icon-close icon-close-popup"
                    data-bs-dismiss="modal"
                    onClick={onClose}
                  ></span>
                </div>
                <div className="tf-login-form">
                  <form onSubmit={handleRegister} autoComplete="off">
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="text"
                        name="fname"
                        value={data.fname}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("First Name")} *
                      </label>
                      {errors.fname && (
                        <div className="error">{errors.fname}</div>
                      )}
                    </div>
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="text"
                        name="lname"
                        value={data.lname}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Last Name")} *
                      </label>
                      {errors.lname && (
                        <div className="error">{errors.lname}</div>
                      )}
                    </div>
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Email")} *
                      </label>
                      {errors.email && (
                        <div className="error">{errors.email}</div>
                      )}
                    </div>
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="password"
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Password")} *
                      </label>
                      {errors.password && (
                        <div className="error">{errors.password}</div>
                      )}
                    </div>
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="text"
                        name="phone"
                        value={data.phone}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Phone Number")} *
                      </label>
                      {errors.phone && (
                        <div className="error">{errors.phone}</div>
                      )}
                    </div>
                    <div className="bottom">
                      <div className="w-100">
                        <button
                          type="submit"
                          className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                          disabled={loading}
                        >
                          {loading
                            ? getWord("In Process")
                            : getWord("Register")}
                        </button>
                        {errors.error && (
                          <div className="error">{errors.error}</div>
                        )}
                      </div>
                      <div className="w-100">
                        <a
                          data-bs-toggle="modal"
                          className="btn-link fw-6 w-100 link"
                          onClick={() => switchTo("login")}
                        >
                          {getWord("Already have an account? Log in here")}
                          <i className="icon icon-arrow1-top-left"></i>
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
          {modalType === "forget_password" && (
            <>
              <div className="modal-content">
                <div className="header">
                  <div className="demo-title">
                    {getWord("Reset your Password")}
                  </div>
                  <span
                    className="icon-close icon-close-popup"
                    data-bs-dismiss="modal"
                    onClick={onClose}
                  ></span>
                </div>
                <div className="tf-login-form">
                  <form onSubmit={handleReset} autoComplete="off">
                    <div className="tf-field style-1">
                      <input
                        className="tf-field-input tf-input"
                        type="email"
                        name="email"
                        value={data.email}
                        onChange={handleChange}
                      />
                      <label className="tf-field-label">
                        {getWord("Email")} *
                      </label>
                      {errors.email && (
                        <div className="error">{errors.email}</div>
                      )}
                    </div>
                    <div>
                      <a
                        data-bs-toggle="modal"
                        className="btn-link link"
                        onClick={() => switchTo("login")}
                      >
                        {getWord("Cancel")}
                      </a>
                    </div>
                    <div className="bottom">
                      <div className="w-100">
                        <button
                          type="submit"
                          className="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"
                          disabled={loading}
                        >
                          {loading
                            ? getWord("Loading")
                            : getWord("Reset Password")}
                        </button>
                        {errors.error && (
                          <div className="error">{errors.error}</div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default Login;
